import { render, staticRenderFns } from "./DataCheckCoverageMap.vue?vue&type=template&id=2e90f3dd&scoped=true&"
import script from "./DataCheckCoverageMap.vue?vue&type=script&lang=js&"
export * from "./DataCheckCoverageMap.vue?vue&type=script&lang=js&"
import style0 from "./DataCheckCoverageMap.vue?vue&type=style&index=0&id=2e90f3dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e90f3dd",
  null
  
)

export default component.exports